import React from 'react';
import {
	AdvancedMarker,
	InfoWindow,
	useAdvancedMarkerRef,
} from '@vis.gl/react-google-maps';

import Img from 'components/Img';
import Text from 'components/Text';

interface Props {
	content: React.ReactNode;
	iconSrc: string;
	isSelected: boolean;
	onClose: () => void;
	onSelectClick: () => void;
	position: { lat: number; lng: number };
	title: string;
}

export default function MarkerWithInfoWindow({
	content,
	iconSrc,
	isSelected,
	onClose,
	onSelectClick,
	position,
	title,
}: Props) {
	const [markerRef, marker] = useAdvancedMarkerRef();
	return (
		<>
			<AdvancedMarker
				title={title}
				ref={markerRef}
				onClick={onSelectClick}
				position={position}
			>
				<Img src={iconSrc} className="size-10 shrink-0 md:size-12" />
			</AdvancedMarker>
			{isSelected && (
				<InfoWindow
					minWidth={300}
					headerContent={
						<Text as="h3" styleAs="h6">
							{title}
						</Text>
					}
					anchor={marker}
					onClose={onClose}
					onCloseClick={onClose}
				>
					{content}
				</InfoWindow>
			)}
		</>
	);
}

MarkerWithInfoWindow.displayName = 'MarkerWithInfoWindow';
